import { render, staticRenderFns } from "./SocialNetwork.vue?vue&type=template&id=c7ccee26&"
import script from "./SocialNetwork.vue?vue&type=script&lang=js&"
export * from "./SocialNetwork.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetwork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports